module.exports = __webpack_public_path__ + "img/长安分校@2x.b3d64797.png";